(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("1tnLK", function(module, exports) {
// Swiper styles



parcelRequire("kbkiQ");
parcelRequire("b9oDT");
parcelRequire("iH7eE");

});
parcelRequire.register("kbkiQ", function(module, exports) {

var $1FCkY = parcelRequire("1FCkY");

var $8h94B = parcelRequire("8h94B");
const $eb14957782c2ef11$var$heroSliders = document.querySelectorAll(".g-hero-slider");
$eb14957782c2ef11$var$heroSliders.forEach((slider)=>{
    const swiperSettings = {
        modules: [
            (0, $8h94B.Keyboard),
            (0, $8h94B.EffectCreative),
            (0, $8h94B.Pagination),
            (0, $8h94B.Navigation)
        ],
        slidesPerView: 1,
        spaceBetween: 8,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: slider.closest(".s-hero-slider")?.querySelector(".g-hero-slider__button.--next"),
            prevEl: slider.closest(".s-hero-slider")?.querySelector(".g-hero-slider__button.--prev")
        },
        pagination: {
            el: slider.querySelector(".g-hero-slider__pagination"),
            clickable: true
        },
        effect: "creative",
        creativeEffect: {
            prev: {
                translate: [
                    0,
                    0,
                    -400
                ],
                opacity: 0
            },
            next: {
                translate: [
                    "calc(100% + 8px)",
                    0,
                    0
                ]
            }
        },
        on: {
            init: ()=>{
                slider.classList.remove("--loading");
            }
        }
    };
    new (0, $1FCkY.default)(slider, swiperSettings);
});

});

parcelRequire.register("b9oDT", function(module, exports) {

var $1FCkY = parcelRequire("1FCkY");

var $8h94B = parcelRequire("8h94B");
const $81e3a673d036e6f0$var$reviewSliders = document.querySelectorAll(".g-review");
$81e3a673d036e6f0$var$reviewSliders.forEach((slider)=>{
    const swiperSettings = {
        modules: [
            (0, $8h94B.Keyboard),
            (0, $8h94B.EffectCreative),
            (0, $8h94B.Navigation)
        ],
        slidesPerView: 1,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: slider.closest(".s-review")?.querySelector(".g-review__button.--next"),
            prevEl: slider.closest(".s-review")?.querySelector(".g-review__button.--prev")
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 32
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 32
            }
        },
        on: {
            init: ()=>{
                slider.classList.remove("--loading");
            }
        }
    };
    new (0, $1FCkY.default)(slider, swiperSettings);
});

});

parcelRequire.register("iH7eE", function(module, exports) {

var $1FCkY = parcelRequire("1FCkY");

var $8h94B = parcelRequire("8h94B");
const $d9c1daeefcbc2762$var$rollerSliders = document.querySelectorAll(".g-roller-slider");
$d9c1daeefcbc2762$var$rollerSliders.forEach((slider)=>{
    const sliderScrollbar = slider.querySelector(".g-roller-slider__scrollbar.swiper-scrollbar");
    const sliderButtons = slider.closest(".s-roller-slider__slider")?.querySelector(".g-roller-slider__buttons");
    const sliderImg = slider.querySelector(".i-roller-slider .img");
    if (!sliderButtons || !sliderImg) return;
    let halfImg;
    const setButtonsOffset = (top)=>{
        sliderButtons.style.setProperty("top", `${top.toString()}px`);
    };
    setTimeout(()=>{
        halfImg = sliderImg.clientHeight / 2;
        setButtonsOffset(halfImg);
    });
    window.addEventListener("resize", ()=>{
        halfImg = sliderImg.clientHeight / 2;
        setButtonsOffset(halfImg);
    });
    const swiperSettings = {
        modules: [
            (0, $8h94B.Keyboard),
            (0, $8h94B.EffectCreative),
            (0, $8h94B.Navigation),
            (0, $8h94B.Scrollbar)
        ],
        slidesPerView: 1,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: slider.closest(".s-roller-slider__slider")?.querySelector(".g-roller-slider__button.--next"),
            prevEl: slider.closest(".s-roller-slider__slider")?.querySelector(".g-roller-slider__button.--prev")
        },
        breakpoints: {
            1200: {
                slidesPerView: 2,
                spaceBetween: 32
            }
        },
        scrollbar: {
            el: sliderScrollbar,
            draggable: true,
            dragSize: "auto"
        },
        on: {
            init: ()=>{
                slider.classList.remove("--loading");
            },
            resize (swiper) {
                swiper.scrollbar.setTranslate();
                swiper.scrollbar.updateSize();
            }
        }
    };
    new (0, $1FCkY.default)(slider, swiperSettings);
});

});


})();
//# sourceMappingURL=swiper.4acb9ae0.js.map
